package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.legal.DayClosure
import com.evoapps.evoshift.domain.legal.LegalCalendarYear
import com.evoapps.evoshift.domain.legal.LegalCalendars
import com.evoapps.evoshift.domain.legal.SundayPolicyRules
import com.evoapps.evoshift.domain.model.SundayPolicy
import com.evoapps.evoshift.domain.model.WorkplaceSettings
import com.evoapps.evoshift.domain.repository.BundledLegalCalendarRepository
import com.evoapps.evoshift.domain.repository.LegalCalendarRepository
import kotlinx.datetime.LocalDate

/**
 * The days of a month a workplace's [SundayPolicy] closes (SH-55), for the skeleton generator, the
 * roster and the daily log. The year's calendar comes from Firestore; when that has none (offline
 * on first run, or not seeded yet) the copy shipped with the app is used. An OPEN workplace reads
 * nothing.
 */
class GetDayClosuresUseCase(
    private val repository: LegalCalendarRepository = BundledLegalCalendarRepository
) {
    suspend operator fun invoke(settings: WorkplaceSettings, year: Int, month: Int): Map<LocalDate, DayClosure> {
        if (settings.sundayPolicy == SundayPolicy.OPEN) return emptyMap()
        val calendar = calendar(settings.market.countryCode, year)
        return SundayPolicyRules.closuresIn(year, month, settings.sundayPolicy, calendar)
    }

    /** Firestore's calendar, else the bundled one, else null (no list for that year). */
    suspend fun calendar(country: String, year: Int): LegalCalendarYear? =
        repository.getYear(country, year).getOrNull() ?: LegalCalendars.bundled(country, year)
}
